import styled from '@emotion/styled';

export const CardWrapper = styled.div`
  padding: 20px;
  border-radius: 16px;
  background: ${({ theme }) => theme.colors.neutralSurface};
`;
